import { StepperConfig, StepperStep } from '@ntv360/component-pantry';

export const DEFAULT_STEPPER_CONFIG: StepperConfig = {
    variant: 'default',
    stepperColor: 'accent',
    labelColor: 'white',
    descriptionColor: 'neutral',
    clickable: true,
    allowSkipping: true,
};

export const PLAYLIST_STEPS: StepperStep[] = [
    {
        id: 'fill-information',
        label: 'Fill Playlist Information',
    },
    {
        id: 'select-assets',
        label: 'Select Assets',
    },
    {
        id: 'settings',
        label: 'Settings',
    },
];
